import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as S from './SiderMenu.styles';
import { sidebarNavigation, SidebarNavigationItem } from '../sidebarNavigation';
import { Menu } from 'antd';

interface SiderContentProps {
  setCollapsed: (isCollapsed: boolean) => void;
  isRoot: boolean;
  isCollapsed: boolean;
}

const sidebarNavFlat = sidebarNavigation(location.pathname.split('/')[1]).reduce(
  (result: SidebarNavigationItem[], current) =>
    result.concat(current.children && current.children.length > 0 ? current.children : current),
  [],
);

const SiderMenu: React.FC<SiderContentProps> = ({ setCollapsed, isRoot, isCollapsed }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const moduleKey = location.pathname.split('/')[1];

  const currentMenuItem = sidebarNavFlat.find(({ url }) => url === location.pathname);
  const defaultSelectedKeys = currentMenuItem ? [currentMenuItem.key] : [];

  const openedSubmenu = sidebarNavigation(moduleKey).find(({ children }) =>
    children?.some(({ url }) => url === location.pathname),
  );
  const defaultOpenKeys = moduleKey === 'kaizen' ? ['actions'] : openedSubmenu ? [openedSubmenu.key] : [];
  const [openKeys, setOpenKeys] = useState<string[]>(defaultOpenKeys);

  useEffect(() => {
    setOpenKeys(defaultOpenKeys);
  }, [location.pathname, moduleKey]);

  useEffect(() => {
    if (!isCollapsed) {
      setOpenKeys(defaultOpenKeys);
    }
  }, [isCollapsed, moduleKey, location.pathname]);

  // setIsRoot(checkRoot());
  return (
    <S.Menu
      mode="inline"
      selectedKeys={defaultSelectedKeys}
      openKeys={openKeys}
      onOpenChange={(keys) => setOpenKeys(keys as string[])}
      onClick={() => setCollapsed(true)}
    >
      {sidebarNavigation(moduleKey).map((nav) =>
        isRoot == true || isRoot == nav.isRoot ? (
          nav.children && nav.children.length > 0 ? (
            <Menu.SubMenu
              key={nav.key}
              title={t(nav.title)}
              icon={nav.icon}
              onTitleClick={() => {
                if (moduleKey === 'fac' && isCollapsed) {
                  setCollapsed(false);
                }
                if (nav.key === 'actions' && !openKeys.includes('actions') && location.pathname.includes('/kaizen/')) {
                  navigate('/kaizen/actions/query');
                }
              }}
              popupClassName="d-none"
            >
              {nav.children.map((childNav) =>
                isRoot == true || isRoot == nav.isRoot ? (
                  <Menu.Item key={childNav.key} title="">
                    <Link to={childNav.url || ''}>{t(childNav.title)}</Link>
                  </Menu.Item>
                ) : (
                  <></>
                ),
              )}
            </Menu.SubMenu>
          ) : (
            <Menu.Item key={nav.key} title="" icon={nav.icon}>
              <Link to={nav.url || ''}>{t(nav.title)}</Link>
            </Menu.Item>
          )
        ) : (
          <></>
        ),
      )}
    </S.Menu>
  );
};

export default SiderMenu;
